export default "__VITE_ASSET__2690fecf__"